
import io from 'socket.io-client';
import { webBaseUrl,socketUrl, notificationMode } from "./../../src/config";
console.log("444",socketUrl);
// "undefined" means the URL will be computed from the `window.location` object

export const socket = io(socketUrl);